var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgNodeCheck = function SvgNodeCheck(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 15 15"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#ECE6A9",
    d: "M7.5.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#node-check_svg__a)",
    d: "M7.5.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#node-check_svg__b)",
    d: "M7.5.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14Z"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE9A8",
    d: "M10.683 5.131a.793.793 0 0 0-1.055.164L6.736 9.063 5.383 7.197a.79.79 0 0 0-1.05-.19.674.674 0 0 0-.204.976l1.962 2.707a.77.77 0 0 0 .617.31h.01c.244 0 .473-.11.615-.295l3.526-4.592a.673.673 0 0 0-.176-.982"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "node-check_svg__a",
    x1: 7.5,
    x2: 7.5,
    y1: 0,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF5B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.154,
    stopColor: "#FFEE82"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.549,
    stopColor: "#F4AE2B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#D18003"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "node-check_svg__b",
    x1: 7.5,
    x2: 7.5,
    y1: 15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgNodeCheck;